export const CalendarDndItemTypes = {
  APPOINTMENT: "calendarAppointment",
};

export interface CalendarDndItem {
  appointment: AppointmentWithSeriesInfo & { invoice?: InvoiceData };
}

export type CalendarDndDropResult =
  | {
      isValid: true;
      rescheduledAppointment: AppointmentWithSeriesInfo & {
        invoice?: InvoiceData;
      };
      onSuccess: () => void;
      onError: () => void;
    }
  | {
      isValid: false;
    };
